import React from 'react';
import { AdditionalPrice } from '../AdditionalPrice';
import { classNames } from '../../../utils/style';

export const ExtraPrice = ({
  currency,
  currencyFirst,
  extraPrice,
  extraPriceLabel,
  displayEmptyLines,
  extraPriceLineThrough,
}: any) => {
  return (
    <AdditionalPrice
      name="extraPrice"
      display={extraPrice}
      displayEmptyLines={displayEmptyLines}
      className={classNames(extraPriceLineThrough && 'line-through')}
    >
      {currencyFirst ? (
        <span>
          +&nbsp;{currency}
          {extraPrice} {extraPriceLabel}
        </span>
      ) : (
        <span>
          +&nbsp;{extraPrice}&nbsp;{currency} {extraPriceLabel}
        </span>
      )}
    </AdditionalPrice>
  );
};
